import { render, staticRenderFns } from "./foodCateList.vue?vue&type=template&id=9f90cab2&scoped=true&"
import script from "./foodCateList.vue?vue&type=script&lang=js&"
export * from "./foodCateList.vue?vue&type=script&lang=js&"
import style0 from "./foodCateList.vue?vue&type=style&index=0&id=9f90cab2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f90cab2",
  null
  
)

export default component.exports